import { Card, Tag } from '@sede-enterprise/shell-ds-react-framework'
import React from 'react'
import ResultChart from './ResultChart'
import { modelStatusSentimentMap } from '../../../util/constants'

const CardContainer = ({ sensor, selectedSensors, startDate, endDate, modelDetails }) => {

    return (
        <Card key={sensor?.id} className='model-results-chart-container'>
            <div className='model-results-chart-header'>
                <h4>{sensor?.id}</h4>

                <Tag

                    sentiment={modelStatusSentimentMap[sensor?.status]}
                    variant='outlined'
                    size='small'
                    shape='round'
                >

                    {sensor?.status}
                </Tag>
            </div>
            <ResultChart id={sensor?.id} list={selectedSensors} start={startDate} end={endDate} modelId={modelDetails?.id} modelStatus={sensor?.status} />
        </Card>
    )
}

export default CardContainer